(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hot-cart-addons"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.hotAddons) return;
    window.hotAddons = 1;
    var D = document, W = window, cache = {}, t;
    var root = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
    function tag(v) { try { if (W.clarity) W.clarity('set', 'hot_cart_addon', v); } catch (e) {} }
    var io = 'IntersectionObserver' in W ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { tag('shown'); io.unobserve(e.target); } });
    }) : null;
    function money(c) {
      var cur = (W.Shopify && W.Shopify.currency && W.Shopify.currency.active) || 'USD';
      try { return new Intl.NumberFormat(D.documentElement.lang || 'en', { style: 'currency', currency: cur, minimumFractionDigits: c % 100 ? 2 : 0 }).format(c / 100); }
      catch (e) { return (c / 100).toFixed(2); }
    }
    // Complementary recommendations for the newest cart line, swapped into the server-rendered cards.
    function comp(row) {
      var pid = row.getAttribute('data-pid'), tpl = row.querySelector('.hot-addon');
      if (!pid || !tpl || row.getAttribute('data-comp')) return;
      cache[pid] = cache[pid] || fetch(root + 'recommendations/products.json?intent=complementary&limit=6&product_id=' + pid)
        .then(function (r) { return r.ok ? r.json() : {}; })
        .then(function (j) { return j.products || []; }, function () { return []; });
      cache[pid].then(function (ps) {
        var gap = +row.getAttribute('data-gap'), skip = row.getAttribute('data-in') || '', ul = tpl.parentNode, list = [];
        ps.forEach(function (p) {
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (v && (p.tags || []).indexOf('custom-link') < 0 && skip.indexOf(',' + p.id + ',') < 0) list.push({ p: p, v: v });
        });
        if (!list.length || !row.isConnected) return;
        list.sort(function (a, b) { return a.v.price - b.v.price; });
        list = list.filter(function (x) { return x.v.price >= gap; }).concat(list.filter(function (x) { return x.v.price < gap; })).slice(0, 3);
        var old = [].slice.call(ul.children);
        ul.textContent = '';
        list.forEach(function (x) {
          var li = tpl.cloneNode(true), img = li.querySelector('img'), b = li.querySelector('button'), src = x.p.featured_image;
          li.setAttribute('data-pid', x.p.id);
          li.setAttribute('data-closes', x.v.price >= gap ? '1' : '0');
          li.querySelector('a').href = x.p.url;
          if (img) img.src = src ? src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=120' : '';
          li.querySelector('.hot-addon__t').textContent = x.p.title;
          li.querySelector('.hot-addon__p').textContent = money(x.v.price) + (x.v.title && x.v.title !== 'Default Title' ? ' \u00b7 ' + x.v.title : '');
          b.setAttribute('data-hot-addon', x.v.id);
          b.setAttribute('aria-label', 'Add ' + x.p.title);
          ul.appendChild(li);
        });
        old.forEach(function (li) {
          var dup = list.some(function (x) { return String(x.p.id) === li.getAttribute('data-pid'); });
          if (ul.children.length < 3 && !dup) ul.appendChild(li);
        });
        var all = [].every.call(ul.children, function (li) { return li.getAttribute('data-closes') === '1'; });
        row.querySelector('.hot-addons__h').textContent = row.getAttribute(all ? 'data-yes' : 'data-no');
        row.setAttribute('data-comp', pid);
      });
    }
    function scan() {
      [].forEach.call(D.querySelectorAll('[data-hot-addons]'), function (row) {
        if (io && !row.hotSeen) { row.hotSeen = 1; io.observe(row); }
        comp(row);
      });
    }
    function boot() {
      scan();
      // The drawer and the cart page re-render (morph) after every cart change: rescan then.
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 150); }).observe(D.body, { childList: true, subtree: true });
    }
    if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();

    D.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-hot-addon]');
      if (!b || b.disabled) return;
      e.preventDefault();
      b.disabled = true;
      b.textContent = 'Adding';
      var secs = [].map.call(D.querySelectorAll('cart-items-component[data-section-id]'), function (c) { return c.getAttribute('data-section-id'); });
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: +b.getAttribute('data-hot-addon'), quantity: 1 }], sections: secs.join(',') || undefined, sections_url: location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw res;
          tag('added');
          return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            // Same event the theme's product form sends: the drawer / cart page morph from res.sections, the bubble
            // takes itemCount, the header announces the count.
            D.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'hot-cart-addon',
              data: { source: 'hot-cart-addon', itemCount: cart.item_count, sections: res.sections } } }));
          });
        })
        .catch(function (err) {
          var gone = err && err.status;
          b.disabled = !!gone;
          b.textContent = gone ? 'Sold out' : 'Add';
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
